import { lazy } from 'react'

// const SellerDashboard = lazy(() => import('../../views/seller/SellerDashboard'))
const AddProduct = lazy(() => import('../../views/storage/AddProduct'))
const Products = lazy(() => import('../../views/storage/Products'))
const EditProduct = lazy(() => import('../../views/storage/EditProduct'))
const StorageOrders = lazy(() => import('../../views/storage/StorageOrders'))
const StorageOrderDetails = lazy(() =>
  import('../../views/storage/StorageOrderDetails')
)
// const DiscountProducts = lazy(() =>
//   import('../../views/seller/DiscountProducts')
// )
// const Orders = lazy(() => import('../../views/seller/Orders'))
// const Payments = lazy(() => import('../../views/seller/Payments'))
// const SellerToAdmin = lazy(() => import('../../views/seller/SellerToAdmin'))
// const SellerToCustomer = lazy(() =>
//   import('../../views/seller/SellerToCustomer')
// )
// const Profile = lazy(() => import('../../views/seller/Profile'))
// const EditProduct = lazy(() => import('../../views/seller/EditProduct'))
// const OrderDetails = lazy(() => import('../../views/seller/OrderDetails'))
// const Pending = lazy(() => import('../../views/Pending'))
// const Deactive = lazy(() => import('../../views/Deactive'))
// const AddBanner = lazy(() => import('../../views/seller/AddBanner'));

export const storageRoutes = [
  {
    path: 'stockAdmin/orders',
    element: <StorageOrders />,
    role: 'stockAdmin',
  },
  {
    path: 'stockAdmin/order/details/:orderId',
    element: <StorageOrderDetails />,
    role: 'stockAdmin',
  },
  {
    path: '/stock/addProducts',
    element: <AddProduct />,
    role: 'stockAdmin',
    // status: 'active',
  },
  {
    path: '/stockAdmin/products',
    element: <Products />,
    role: 'stockAdmin',
  },
  {
    path: '/stockAdmin/edit-product/:productId',
    element: <EditProduct />,
    role: 'stockAdmin',
  },
]
